<template>
  <v-dialog
    v-model="isShow"
    :showClose="showClose"
    :width="width+'px'"
    @closed="handleCancel">
    <div class="dialog-container">
      <div class="dialog-header">
        <span>{{title}}</span>
      </div>
      <div class="dialog-body">
        <slot></slot>
      </div>
      <template v-if="hasButton">
        <div
          v-if="!isUnitButton"
          class="dialog-footer">
          <v-button
            gray
            @click="handleCancel">{{cancelText?cancelText:'Cancel'}}</v-button>
          <div>
            <v-button
              v-if="buttonFirstRightText"
              @click="handleRightNext">
              {{buttonFirstRightText}}
            </v-button>
            <v-button
              :green="!isError"
              :red="isError"
              @click="handleNext">
              {{buttonRightText}}
            </v-button>
          </div>
        </div>
        <div
          v-else
          class="dialog-footer unit-button">
          <v-button
            :class="{'footer-button':isPlain}"
            @click="handleCancel">{{unitText}}</v-button>
        </div>
      </template>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: 'dialogComponent',
  props:{
    isShow:{
      type:Boolean,
      default:false
    },
    isUnitButton:{
      type:Boolean,
      default:false
    },
    hasButton:{
      type:Boolean,
      default:true
    },
    isPlain:{
      type:Boolean,
      default:false
    },
    isError:{
      type:Boolean,
      default:false
    },
    width:{
      type:[Number,String],
      default:400
    },
    unitText:{
      type:[Number,String],
      default:'Close'
    },
    dialogData:{
      type:Object,
      default:()=>({})
    },
    showClose:{
      type:Boolean,
      default:false
    }
  },
  computed:{
    title(){
      let {title=''} = this.dialogData||{}
      return title||''
    },
    buttonRightText(){
      let {buttonRightText=''} = this.dialogData||{}
      return buttonRightText||'Continue'
    },
    buttonFirstRightText(){
      let {buttonFirstRightText=''} = this.dialogData||{}
      return buttonFirstRightText
    },
    cancelText(){
      let {cancelText=''} = this.dialogData||{}
      return cancelText
    },
  },
  methods:{
    handleCancel(){
      this.$emit('cancel')
    },
    handleNext(){
      this.$emit('next')
    },
    handleRightNext(){
      this.$emit('rightNext')
    },
  }
}
</script>

<style scoped lang="scss">
  ::v-deep .el-dialog{
    box-sizing: border-box;
    border-radius: 6px;
    font-family: 'inter';
  }
  .dialog-container {
    .dialog-header {
      padding: 16px;
      background: #F6F8FA;
      border-bottom: 1px solid #E1E4E8;
      border-radius: 6px 6px 0 0;
      span{
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        display: flex;
        align-items: center;
        color: #1B1F23;
        flex: none;
        order: 0;
        align-self: stretch;
        flex-grow: 0;
        /*margin: 10px 0px;*/
      }
    }
    .dialog-body{
      padding: 20px 15px;
    }
    .dialog-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px;
      .el-button{
        background: #FAFBFC;
        /* btn/border */
        border: 1px solid rgba(27, 31, 35, 0.15);
        box-sizing: border-box;
        /* btn/shadow */
        box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.04);
        border-radius: 6px;
      }
      .footer-button{
        background: #2EA44F;
        color: #FFFFFF;
      }
    }
    >.unit-button{
      .el-button{
        width: 100%;
      }
    }
  }
</style>
